import React, { PropsWithChildren, useState } from 'react';

import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { ApiError } from 'shared/api';

const BaseQueryClientProvider = ({ children }: PropsWithChildren) => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        queryCache: new QueryCache({
          onError: (error: unknown) => {
            // NOTE: Only handler ApiError that is not handled by their own error handler
            if (error instanceof ApiError) {
              alert(error.message);
            }
          },
        }),

        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,

            // NOTE: 500 에러가 발생하면 에러 바운더리에서 처리
            throwOnError: (error) => {
              return error instanceof AxiosError && error.status === 500;
            },
          },

          mutations: {
            // NOTE: 500 에러가 발생하면 에러 바운더리에서 처리
            throwOnError: (error) => {
              return error instanceof AxiosError && error.status === 500;
            },
          },
        },
      }),
  );

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};

export default BaseQueryClientProvider;
